<template>
  <transition name="Breadcrumb">
    <div class="Breadcrumb" v-if="trans('tooltip')[index - 1]" @mouseover="tooltip = true" @mouseleave="tooltip = false">
      <transition name="Tooltip">
        <div class="Tooltip" v-if="tooltip">
          {{ trans('tooltip')[index - 1] }}
        </div>
      </transition>
      <div class="Breadcrumb__text">
        {{ trans('text')[index - 1] }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data: () => ({
    index: 0,
    tooltip: false
  }),
  translations: {
    fr: {
      text: [
        'DEFI 1',
        'DEFI 2',
        'DEFI 3',
      ],
      tooltip: [
        'Choisis trois mots correspondants à cette œuvre.',
        'Que ressens-tu devant ce portrait ?',
        'Crée ton propre portrait : tu peux te représenter toi-même ou représenter quelqu’un d’autre.',
      ],
    },
    en: {
      text: [
        'CHALLENGE 1',
        'CHALLENGE 2',
        'CHALLENGE 3',
      ],
      tooltip: [
        'Choose three words that go with this artwork.',
        'What do you feel when you look at this portrait?',
        'Create your own portrait: you can portray yourself or portray someone else.',
      ],
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.slugIsAfter('instructions'))
          this.index = 1

        if(this.slugIsAfter('grenier:2'))
          this.index = 2

        if(this.slugIsAfter('27'))
          this.index = 3 
      },
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Breadcrumb
  position fixed
  color black
  top 21px
  left 70px
  font-size 12px
  font-weight 700
  transition opacity 1s
  border 3px solid white
  color white
  padding 1px 20px 1px
  cursor default
  line-height 21px
  &-enter
  &-leave-active
    opacity 0

  &__text
    position relative
    top 1px
    letter-spacing .2em
    line-height 21px

</style>



// WEBPACK FOOTER //
// src/components/navigation/Breadcrumb.vue